import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MessagesModule } from 'primeng/messages';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToastModule } from 'primeng/toast';

import { FormFieldHelpComponent } from '../../form/form-field-help/form-field-help.component';
import { AccordionWizardModule } from '../../generic/accordion-wizard/accordion-wizard.module';
import { DataTableModule } from '../../generic/data-table/data-table.module';
import { ObjAutocompleteV2Module } from '../../generic/obj-autocomplete-v2/obj-autocomplete-v2.module';
import { SettingsModule } from '../../generic/settings/settings.module';
import { ArrayOfPhonesEditorModule } from '../array-of-phones-editor/array-of-phones-editor.module';
import { CallListCommunicationWorkflowConfigEditorComponent } from '../call-list-communication-workflow-config/call-list-communication-workflow-config-editor/call-list-communication-workflow-config-editor.component';
import { CallListOfferConfigRingTimeModule } from '../call-list-offer-config-ring-time/call-list-offer-config-ring-time.module';
import { CallerIdStrategyEditorComponent } from '../caller-id-strategy/caller-id-strategy-editor/caller-id-strategy-editor.component';
import { CommunicationWorkflowAutocompleteComponent } from '../communication-workflow/communication-workflow-autocomplete/communication-workflow-autocomplete.component';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';
import { ServiceOperationEditorModule } from '../service-operation-editor/service-operation-editor.module';
import { WorkersAutocompleteModule } from '../workers-autocomplete/workers-autocomplete.module';

import { CallListEditorComponent } from './editor/call-list-editor/call-list-editor.component';
import { CallListTableEditorComponent } from './editor-table/call-list-table-editor/call-list-table-editor.component';
import { CallListTableEditorExpansionComponent } from './editor-table/call-list-table-editor-expansion/call-list-table-editor-expansion.component';
import { CallListAutocompleteModule } from './select/call-list-autocomplete/call-list-autocomplete.module';

@NgModule({
  declarations: [
    CallListCommunicationWorkflowConfigEditorComponent,
    CallListEditorComponent,
    CallListTableEditorComponent,
    CallListTableEditorExpansionComponent,
  ],
  imports: [
    AccordionModule,
    AccordionWizardModule,
    ArrayOfPhonesEditorModule,
    AutoCompleteModule,
    CallerIdStrategyEditorComponent,
    CallListAutocompleteModule,
    CallListOfferConfigRingTimeModule,
    CommonModule,
    CommunicationWorkflowAutocompleteComponent,
    DataTableModule,
    DropdownModule,
    FormFieldHelpComponent,
    FormsModule,
    InputTextareaModule,
    InputTextModule,
    MatIconModule,
    MessagesModule,
    ObjAutocompleteV2Module,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    SelectButtonModule,
    ServiceOperationEditorModule,
    SettingsModule,
    ToastModule,
    TranslocoModule,
    WorkersAutocompleteModule,
  ],
  exports: [CallListAutocompleteModule, CallListTableEditorComponent],
})
export class CallListModule {}
